import * as d3 from "d3"
import D3AverageRangeBarBase from './d3_average_range_bar_base'

export default class D3AverageRangeBarSingle extends D3AverageRangeBarBase {

  _loadMargins() {
    this.margins = {}
    this.margins.chart = {top: 18, right: 60, bottom: 10, left: 0}
    this.margins.footer = {top: 0, right: 60, bottom: 0, left: 0}
  }

  _loadColors() {
    this.colors = this.opts.colors || ['#3288BD']
  }

  draw() {
    this.charts.forEach((d) => {
      this._drawGraph(d)
      d.container = d.svg.append('g').attr('class', 'd3-chart').attr('transform', d.dimensions.chart.transform)
      this._drawBars(d)
      this._drawMinMaxText(d, 'min')
      this._drawMinMaxText(d, 'max')
      d.container.append('g').attr('class', 'averages')
      this._drawAverages(d)
      this._drawAveragesText(d)
    })
    this._drawFooter()
  }

}
